import React from "react";
import PropTypes from "prop-types";
import { Controller, useFormContext } from "react-hook-form";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function RHFAutocomplete({
  isRequired = false,
  name,
  data,
  onInputChange,
  defaultValue,
  label,
  helperText,
  placeholder,
  control,
  setValue,
  borderRadius,
  ...other
}) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <Autocomplete
            size="small"
            {...field}
            id={name}
            onChange={(e, value) => {
              if (!value) {
                setValue(name, "", { shouldValidate: true });
              } else {
                setValue(name, value, { shouldValidate: true });
              }
              onInputChange(value);
            }}
            options={data?.map((option) => option.label)}
            getOptionLabel={(option) => {
              return option || "";
            }}
            renderInput={(params) => (
              <TextField
                sx={{
                  "& .MuiOutlinedInput-root": {
                    borderRadius: borderRadius,
                  },
                }}
                required={isRequired}
                {...params}
                label={label}
                placeholder={placeholder}
                error={!!error}
                helperText={error ? error.message : helperText}
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password",
                  style: {
                    borderRadius: "20px",
                  },
                }}
              />
            )}
            {...other}
          />
        </>
      )}
    />
  );
}

RHFAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  helperText: PropTypes.string,
  placeholder: PropTypes.string,
  control: PropTypes.object.isRequired,
  setValue: PropTypes.func.isRequired,
};
